// tslint:disable
/**
 * Sprungkraft Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Observable } from 'rxjs';
import type { AjaxResponse } from 'rxjs/ajax';
import { BaseAPI, throwIfNullOrUndefined, encodeURI } from '../runtime';
import type { OperationOpts, HttpHeaders } from '../runtime';
import type {
    ChangeSetting,
    Setting,
} from '../models';

export interface ChangeSettingRequest {
    key: string;
    changeSetting: ChangeSetting;
}

export interface GetSettingRequest {
    key: string;
}

/**
 * no description
 */
export class SettingApi extends BaseAPI {

    /**
     */
    changeSetting({ key, changeSetting }: ChangeSettingRequest): Observable<Setting>
    changeSetting({ key, changeSetting }: ChangeSettingRequest, opts?: OperationOpts): Observable<AjaxResponse<Setting>>
    changeSetting({ key, changeSetting }: ChangeSettingRequest, opts?: OperationOpts): Observable<Setting | AjaxResponse<Setting>> {
        throwIfNullOrUndefined(key, 'key', 'changeSetting');
        throwIfNullOrUndefined(changeSetting, 'changeSetting', 'changeSetting');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
            ...(this.configuration.apiKey && { 'X-API-KEY': this.configuration.apiKey('X-API-KEY') }), // defaultAuth authentication
        };

        return this.request<Setting>({
            url: '/setting/{key}'.replace('{key}', encodeURI(key)),
            method: 'PATCH',
            headers,
            body: changeSetting,
        }, opts?.responseOpts);
    };

    /**
     */
    getSetting({ key }: GetSettingRequest): Observable<Setting>
    getSetting({ key }: GetSettingRequest, opts?: OperationOpts): Observable<AjaxResponse<Setting>>
    getSetting({ key }: GetSettingRequest, opts?: OperationOpts): Observable<Setting | AjaxResponse<Setting>> {
        throwIfNullOrUndefined(key, 'key', 'getSetting');

        return this.request<Setting>({
            url: '/setting/{key}'.replace('{key}', encodeURI(key)),
            method: 'GET',
        }, opts?.responseOpts);
    };

}
